export default __webpack_public_path__ + "static/media/scatterReel.10c5b111.mp3";